/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import styles from "../../clients.module.scss";

const useStyles = makeStyles((theme) => ({
  shiftTitle: {
    display: "flex",
    alignItems: "center",
    padding: "8px",
    borderRadius: "40px",
    width: "fit-content",
    border: "1px solid hsl(214.3, 31.8%, 91.4%)",
  },
  selectwrap: {
    background: "#fff",
    color: "#000",
    minWidth: "170px",
  },
  shiftTaskListwrap: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
    },
  },
  shiftTaskList: {
    marginTop: "10px",
    marginBottom: "20px",
    flex: "1",
    fontSize: "16px",
    lineHeight: "20px",
  },
}));
function SummaryListItem(props) {
  const classes = useStyles();
  const { List } = props;

  const taskIds = useMemo(
    () => List?.flatMap((it) => (it.tasks || [])?.map((t) => t.taskId ?? t.id)),
    [List]
  );

  const allTasks = useMemo(
    () => [...(props?.standardTasks || []), ...(props?.customtaskList || [])],
    [props?.standardTasks, props?.customtaskList]
  );

  const selectedTasks = useMemo(() => {
    const shiftId = props?.shift?.shiftId;
    return (allTasks || [])?.filter((t) => {
      const idMatches = taskIds?.includes(t.taskId ?? t.id);
      if (!idMatches) return false;

      if (t?.custom) {
        return t?.shift === shiftId;
      }
      return true;
    });
  }, [allTasks, taskIds, props?.shift?.shiftId]);

  const removeTaskGroupSummaryList = (item) => {
    if (item && props?.removeSummaryListItem) {
      props?.removeSummaryListItem(item);
    }
  };

  return (
    <>
      <div className={`${classes.shiftTitle} dark:text-white`}>
        {List[0]?.frequency}
      </div>
      <div className={`${classes.shiftTaskListwrap} mt-16`}>
        {selectedTasks?.map((task) => (
          <div
            key={task.taskId ?? task.id}
            className={`${styles.taskItem} dark:bg-gray-900`}
          >
            <span className="dark:text-white">{task?.title}</span>
            <CloseOutlinedIcon
              className={styles.removeIcon}
              onClick={() => removeTaskGroupSummaryList(task)}
            />
          </div>
        ))}
      </div>
    </>
  );
}

export default function TaskSummaryList(props) {
  const allFrequencies = props?.taskFrequencies
    ? props?.taskFrequencies
    : props?.SummaryFrequencyListarr;

  return (
    <ul>
      {allFrequencies?.map((frequency, idx) => {
        const List = (props?.SummaryList || [])?.filter(
          (s) => s.frequency === frequency
        );
        const mergedList = List?.map((summaryItem) => {
          const matchedCustomTasks = (props?.customtaskList || [])?.filter(
            (c) =>
              c.frequency === frequency &&
              c.shift === summaryItem.shift.shiftId
          );

          if (matchedCustomTasks?.length === 0) return summaryItem;

          return {
            ...summaryItem,
            tasks: [
              ...(summaryItem.tasks || []),
              ...matchedCustomTasks?.map((c) => ({
                taskId: c.taskId,
                title: c.title,
                custom: true,
              })),
            ],
          };
        });

        if (!mergedList?.length) return null;

        return (
          <li key={`summary-${frequency}-${idx}`}>
            <SummaryListItem item={frequency} List={mergedList} {...props} />
          </li>
        );
      })}
    </ul>
  );
}
